import React from 'react'
import BaseIcon from 'react-icon-base'

const ArrowToCompletedActivity = props => (
  <BaseIcon width="23" height="102" viewBox="0 0 23 102" style={{ marginTop: 110 }} {...props}>
    <g>
      <path
        fill="#2ED8A7"
        fillRule="evenodd"
        d="M14.468 94.724c.561.01 1.104-.345.994-1.04l-.952-5.977 4.972 10.852-10.027-4.203c1.302.266 2.6.57 3.904.95.571.167.963-.15 1.109-.582zm8 5.449l-9.174-20.017c-.443-.966-2.183-.816-1.987.413l1.48 9.286C3.985 77.277 1.187 61.81 2.267 46.54c.586-8.287 2.2-16.486 4.329-24.507C8.63 14.368 11.309 6.94 16.684.954c.509-.567-.36-1.303-.886-.769-5.289 5.366-8.253 12.09-10.383 19.232C2.722 28.444.813 37.794.19 47.203-.884 63.43 2.517 79.97 12.55 92.981c-3.411-.9-6.824-1.413-10.37-1.557-1.02-.04-1.285 1.563-.383 1.942l19.25 8.067c.745.313 1.822-.385 1.42-1.26z"
      />
    </g>
  </BaseIcon>
)

export default ArrowToCompletedActivity
